const Theme = {
  body_background_color: '#373F56',

  logo_image_url: 'sept-iles.png',
  logo_height: 120,

  token_hidden: true,
  number_hidden: true,

  text_font: `'Circular', sans-serif`,

  button_color: '#c99b42',
  button_font: `'Circular', sans-serif`,
  button_radius: 15,

  title_font: `'Montserrat', 'serif'`,
}

export default Theme
